export default __webpack_public_path__ + "static/media/Republic3.ba48fc4a.png";